import React, { useState, useEffect } from 'react';
import SellModalSC, { ErrorWrapSC, ErrorText } from './sell-modal.styled';
import { HeadingTwo /* BodyText, SmallText  */ } from '../../typography';
import InlineLoading from '../../ui/inline-loading';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import dlt from '../../../utils/default-lang';
import SectionSwitch from './section-switch';
import Button from '../../ui/button';
import HeadingFour from '../../typography/heading-four';
import SmallText from '../../typography/small-text';
import BodyText from '../../typography/body-text';
import InputGroup from '../../ui/input';
import Moment from 'react-moment';
import numeral from 'numeral';
import Checkbox from '../../ui/checkbox/checkbox';
import DocumentsVerification from '../../ui/documents-verification';

const SellModal = ({ investmentDetail, dashboardData, onSubmit, intl, activeStep, documents }) => {
  const [activeType, setActiveType] = useState('automatic');
  const [sellAmount, setSellAmount] = useState(
    numeral(Number(investmentDetail.investor.totalTillEnd[9])).format('0,00.00')
  );
  const [sellPart, setSellPart] = useState(
    numeral(Number(investmentDetail.investor.totalTillEnd[9])).format('0,00.00')
  );
  /* guarantee fund sell errors */
  const [isGuaranteeError, setIsGuaranteeError] = useState(false);
  const [errorGuaranteeType, setErrorGuaranteeType] = useState('');

  /* automatic sell errors */
  const [errorAutomaticType, setErrorAutomaticType] = useState('');
  const [isAutomaticError, setIsAutomaticError] = useState(false);

  const [vop, setVop] = useState(false);
  const [unsuccess, setUnsuccess] = useState(false);
  const [success, setSuccess] = useState(false);

  const [guaranteeConfirm, setGuaranteeConfirm] = useState(false);
  const [guaranteeNotChangeConfirm, setGuaranteeNotChangeConfirm] = useState(false);

  const [areAllRead, setAllRead] = useState(false);
  const [numberIsBigger, setNumberIsBigger] = useState(false);

  const setDocumentsToAllRead = (status) => {
    setAllRead(status);
  };

  useEffect(() => {
    setAllRead(false);
  }, [documents]);

  useEffect(() => {
    if (!investmentDetail || !investmentDetail.investor) {
      return;
    }

    if (Number(investmentDetail.investor.totalTillEnd[12]) > 0) {
      setErrorAutomaticType('is_in_delay');
      setIsAutomaticError(true);
    } else {
      setIsAutomaticError(false);
      setErrorAutomaticType('');
    }
  }, [investmentDetail]);

  useEffect(() => {
    if (
      !investmentDetail ||
      !investmentDetail.investor ||
      !dashboardData ||
      !dashboardData.balance
    ) {
      return;
    }

    if (Number(investmentDetail.investor.totalTillDue[12]) <= 120) {
      setErrorGuaranteeType('small_delay');
      setIsGuaranteeError(true);
    } else if (Number(dashboardData.balance.guaranteeFund) <= 0) {
      setErrorGuaranteeType('fund_balance');
      setIsGuaranteeError(true);
    } else if (Number(investmentDetail.investor.totalTillEnd[8]) === 0) {
      setErrorGuaranteeType('is_paid');
      setIsGuaranteeError(true);
    } else {
      setIsGuaranteeError(false);
      setErrorGuaranteeType('');
    }
  }, [investmentDetail, dashboardData]);

  const categories = [
    {
      label: 'investor_loan_detail_sell_modal_automatic',
      name: 'automatic',
      disabled: activeStep > 1 ? true : false,
    },
    {
      label: 'investor_loan_detail_sell_modal_manual',
      name: 'manual',
      disabled: activeStep > 1 ? true : false,
    },
    {
      label: 'investor_loan_detail_sell_modal_guarantee_fund',
      name: 'guarantee_fund',
    },
  ];

  const setActiveCategory = (category) => {
    setActiveType(category);
    setVop(false);
    setUnsuccess(false);
    setSuccess(false);
  };

  const onSell = (activeStep) => {
    if (sellAmount !== '' && sellPart !== '' && activeType === 'manual') {
      onSubmit({
        type: activeType,
        price: Number(sellAmount.replace(/ /g, '').replace(/,/g, '.')),
        value: Number(sellPart.replace(/ /g, '').replace(/,/g, '.')),
      });
    } else if (activeType === 'guarantee_fund') {
      onSubmit({ type: activeType, activeStep: activeStep });
    } else {
      onSubmit({ type: activeType });
    }
  };

  const onAmountChange = (e) => {
    const re = /^[\d+\s?]+,?(\d+)?$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setSellAmount(e.target.value);
    }
  };

  const onPartChange = (e) => {
    const maxValue = Number(investmentDetail.investor.totalTillEnd[9]);
    const re = /^[\d+\s?]+,?(\d+)?$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      if (Number(e.target.value.replace(/ /g, '').replace(/,/g, '.')) > maxValue) {
        // setSellPart(numeral(Number(maxValue)).format('0,00.00'));
        setNumberIsBigger(true);
      } else {
        setNumberIsBigger(false);
      }
      setSellPart(e.target.value);
    }
  };

  function renderApprovals() {
    return (
      <>
        <div className="checkbox-wrap">
          <Checkbox
            name="vop"
            hasError={false}
            value={vop}
            checked={vop || false}
            onChange={() => setVop(!vop)}
            withInsideContent
            bold={false}
          >
            <FormattedHTMLMessage
              id="investor_loan_detail_sell_modal_vop_label"
              defaultMessage={dlt['investor_loan_detail_sell_modal_vop_label']}
              values={{
                link1: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/vseobecne_obchodne_podmienky.pdf`,
                link2: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/sadzobnik_poplatkov.pdf`,
              }}
            />
          </Checkbox>
        </div>
        <div className="checkbox-wrap">
          <Checkbox
            name="unsuccess"
            hasError={false}
            value={unsuccess}
            checked={unsuccess || false}
            onChange={() => setUnsuccess(!unsuccess)}
            withInsideContent
            bold={false}
          >
            <FormattedHTMLMessage
              id="investor_loan_detail_sell_modal_unsuccessful_label"
              defaultMessage={dlt['investor_loan_detail_sell_modal_unsuccessful_label']}
            />
          </Checkbox>
        </div>
        <div className="checkbox-wrap">
          <Checkbox
            name="success"
            hasError={false}
            value={success}
            checked={success || false}
            onChange={() => setSuccess(!success)}
            withInsideContent
            bold={false}
          >
            {activeType === 'automatic' ? (
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_successful_label_automatic"
                defaultMessage={dlt['investor_loan_detail_sell_modal_successful_label_automatic']}
              />
            ) : (
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_successful_label"
                defaultMessage={dlt['investor_loan_detail_sell_modal_successful_label']}
              />
            )}
          </Checkbox>
        </div>
      </>
    );
  }

  if (investmentDetail === null || Object.keys(investmentDetail).length < 1) {
    return (
      <SellModalSC>
        <div className="modal-loading-wrap">
          <InlineLoading />
        </div>
      </SellModalSC>
    );
  }
  return (
    <SellModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage
            id="investor_loan_detail_sell_modal_headline"
            defaultMessage={dlt['investor_loan_detail_sell_modal_headline']}
          />
        </HeadingTwo>
      </div>
      <div className="section-switch-wrap">
        <SectionSwitch
          categories={categories}
          isActive={activeType}
          setActiveCategory={(category) => setActiveCategory(category)}
        />
      </div>

      {activeType === 'guarantee_fund' && (
        <div className="gf-free">
          <div className="value">{`${numeral(Number(dashboardData.balance.guaranteeFund)).format(
            '0,00.00'
          )} €`}</div>
          <div className="text">
            <FormattedMessage
              id="investor_loan_detail_sell_modal_type_guarantee_fund_free"
              defaultMessage={dlt['investor_loan_detail_sell_modal_type_guarantee_fund_free']}
            />
          </div>
        </div>
      )}

      {activeType === 'automatic' || activeType === 'guarantee_fund' ? (
        <>
          <div className={`loan-summary-wrap ${activeType}`}>
            <div className="loan-summary-wrap--top">
              <HeadingFour className="bold">{investmentDetail.debtor.wmNumber}</HeadingFour>

              {activeType === 'guarantee_fund' ? (
                <SmallText className="smaller bolder">
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_type_guarantee_fund_copy"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_type_guarantee_fund_copy']}
                  />
                </SmallText>
              ) : (
                <SmallText className="smaller bolder">
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_type_automatic_copy"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_type_automatic_copy']}
                  />
                </SmallText>
              )}
            </div>
            <div className="divider"></div>
            <div className="loan-summary-wrap--bottom">
              <div className="loan-summary-wrap--bottom__row">
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_receivable_value"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_receivable_value']}
                  />
                </SmallText>
                <BodyText className="bolder">
                  {numeral(Number(investmentDetail.investor.totalTillEnd[9])).format('0,00.00')} €
                </BodyText>
              </div>
              <div className="loan-summary-wrap--bottom__row">
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_payments"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_payments']}
                  />
                </SmallText>
                <BodyText className="bolder">
                  {investmentDetail.status.paidInstallmentCount} /{' '}
                  {investmentDetail.installmentCount}
                </BodyText>
              </div>
              <div className="loan-summary-wrap--bottom__row">
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_date"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_date']}
                  />
                </SmallText>
                <BodyText className="bolder">
                  <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                    {investmentDetail.loanDueAt}
                  </Moment>
                </BodyText>
              </div>
              <div className="loan-summary-wrap--bottom__row">
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_status"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_status']}
                  />
                </SmallText>
                <BodyText className="bolder">
                  {Number(investmentDetail.investor.totalTillEnd[12]) > 0
                    ? 'V omeškaní'
                    : 'Uhradené'}
                </BodyText>
              </div>
            </div>
          </div>

          {/* Handling errors */}
          {activeType === 'guarantee_fund' && isGuaranteeError ? (
            <ErrorWrapSC>
              <BodyText className="bold red">
                <FormattedMessage id="global_alert" defaultMessage={dlt['global_alert']} />
              </BodyText>
              <BodyText className="red">
                {errorGuaranteeType === 'small_delay' ? (
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_error_delay"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_error_delay']}
                  />
                ) : errorGuaranteeType === 'fund_balance' ? (
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_error_fund_balance"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_error_fund_balance']}
                  />
                ) : errorGuaranteeType === 'is_paid' ? (
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_error_is_paid"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_error_is_paid']}
                  />
                ) : null}
              </BodyText>
            </ErrorWrapSC>
          ) : activeType === 'automatic' && isAutomaticError ? (
            <ErrorWrapSC>
              <BodyText className="bold red">
                <FormattedMessage id="global_alert" defaultMessage={dlt['global_alert']} />
              </BodyText>
              <BodyText className="red">
                {errorAutomaticType === 'is_in_delay' ? (
                  <FormattedMessage
                    id="investor_loan_detail_sell_modal_error_is_in_delay"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_error_is_in_delay']}
                  />
                ) : null}
              </BodyText>
            </ErrorWrapSC>
          ) : null}

          {(activeType === 'automatic' && isAutomaticError) || activeType === 'guarantee_fund'
            ? null
            : renderApprovals()}

          {activeType === 'guarantee_fund' && activeStep === 1 && !isGuaranteeError ? (
            <>
              <div className="checkbox-wrap">
                <Checkbox
                  name="guaranteeConfirm"
                  hasError={false}
                  value={guaranteeConfirm}
                  checked={guaranteeConfirm || false}
                  onChange={() => setGuaranteeConfirm(!guaranteeConfirm)}
                  withInsideContent
                  bold={false}
                >
                  <FormattedHTMLMessage
                    id="investor_loan_detail_sell_modal_guarantee_label"
                    defaultMessage={dlt['investor_loan_detail_sell_modal_guarantee_label']}
                    values={{
                      link1: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/vseobecne_obchodne_podmienky.pdf`,
                    }}
                  />
                </Checkbox>
              </div>

              <div className="checkbox-wrap">
                <Checkbox
                  name="guaranteeNotChangeConfirm"
                  hasError={false}
                  value={guaranteeNotChangeConfirm}
                  checked={guaranteeNotChangeConfirm || false}
                  onChange={() => setGuaranteeNotChangeConfirm(!guaranteeNotChangeConfirm)}
                  withInsideContent
                  bold={false}
                >
                  <FormattedHTMLMessage
                    id="investor_loan_detail_sell_modal_guarantee_not_change_label"
                    defaultMessage={
                      dlt['investor_loan_detail_sell_modal_guarantee_not_change_label']
                    }
                  />
                </Checkbox>
              </div>
            </>
          ) : null}

          {activeType === 'guarantee_fund' && activeStep === 2 ? (
            <>
              <DocumentsVerification
                documents={documents}
                setDocumentsToAllRead={(status) => setDocumentsToAllRead(status)}
              />
              <SmallText className="hint black-transparent">
                <FormattedMessage
                  id="global_all_docs_hint"
                  defaultMessage={dlt['global_all_docs_hint']}
                />
              </SmallText>
            </>
          ) : null}

          {activeType === 'guarantee_fund' && activeStep === 3 ? (
            <>
              <DocumentsVerification
                documents={documents}
                setDocumentsToAllRead={(status) => setDocumentsToAllRead(status)}
              />
              <SmallText className="hint black-transparent">
                <FormattedMessage id="global_doc_hint" defaultMessage={dlt['global_doc_hint']} />
              </SmallText>
            </>
          ) : null}

          {/* Handling submit */}
          <div className="submit-wrap">
            {activeType === 'guarantee_fund' && activeStep === 1 ? (
              <Button
                type="PRIMARY"
                size="BIG"
                onClick={() => onSell(activeStep)}
                disabled={isGuaranteeError || !guaranteeConfirm || !guaranteeNotChangeConfirm}
              >
                <FormattedMessage id="global_continue" defaultMessage={dlt['global_continue']} />
              </Button>
            ) : activeType === 'guarantee_fund' && activeStep === 2 ? (
              <Button
                type="PRIMARY"
                size="BIG"
                onClick={() => onSell(activeStep)}
                disabled={isGuaranteeError || !areAllRead}
              >
                <FormattedMessage id="global_continue" defaultMessage={dlt['global_continue']} />
              </Button>
            ) : activeType === 'guarantee_fund' && activeStep === 3 ? (
              <Button
                type="PRIMARY"
                size="BIG"
                onClick={() => onSell(3)}
                disabled={isGuaranteeError || !areAllRead}
              >
                <FormattedMessage id="global_sell" defaultMessage={dlt['global_sell']} />
              </Button>
            ) : (
              <Button
                type="PRIMARY"
                size="BIG"
                onClick={() => onSell()}
                disabled={!vop || !unsuccess || !success}
              >
                <FormattedMessage
                  id="global_offer_to_sell"
                  defaultMessage={dlt['global_offer_to_sell']}
                />
              </Button>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="manual-sell-wrap">
            <InputGroup
              value={sellPart}
              placeholder={`${numeral(Number(investmentDetail.investor.totalTillEnd[9])).format(
                '0,00.00'
              )} €`}
              label={intl.formatMessage({
                id: `investor_loan_detail_sell_modal_manual_input_part_label`,
              })}
              onChange={(e) => onPartChange(e)}
            />
            {numberIsBigger && (
              <ErrorText>
                <FormattedMessage
                  id="investor_loan_detail_sell_modal_manual_input_bigger_error"
                  defaultMessage={dlt['investor_loan_detail_sell_modal_manual_input_bigger_error']}
                />
              </ErrorText>
            )}

            <InputGroup
              value={sellAmount}
              placeholder={`${numeral(Number(investmentDetail.investor.totalTillEnd[9])).format(
                '0,00.00'
              )} €`}
              label={intl.formatMessage({
                id: `investor_loan_detail_sell_modal_manual_input_label`,
              })}
              onChange={(e) => onAmountChange(e)}
            />
          </div>
          {/* 
          <div className="checkbox-wrap">
            <DocumentCheck
              onClick={() => checkDocument(generatedDocument.url)}
              title={generatedDocument.title}
            />
            <SmallText className="hint black-transparent">
              <FormattedMessage id="global_doc_hint" defaultMessage={dlt['global_doc_hint']} />
            </SmallText>
          </div> */}

          {renderApprovals()}

          <div className="submit-wrap">
            <Button
              type="PRIMARY"
              size="BIG"
              onClick={() => onSell()}
              disabled={
                !vop ||
                !unsuccess ||
                !success ||
                sellAmount === '' ||
                sellAmount === null ||
                sellAmount === ',' ||
                parseFloat(sellAmount.replace(',', '.')) === 0 ||
                sellPart === '' ||
                sellPart === null ||
                sellPart === ',' ||
                parseFloat(sellPart.replace(',', '.')) === 0
                  ? true
                  : false || numberIsBigger
              }
            >
              <FormattedMessage
                id="global_offer_to_sell"
                defaultMessage={dlt['global_offer_to_sell']}
              />
            </Button>
          </div>
        </>
      )}
    </SellModalSC>
  );
};

export default injectIntl(SellModal);
